import styled from 'styled-components';

export const Background = styled.div`
  min-height: 100%;
  height: calc(min-content + 100%);

  background: #f1f4f5;
`;

export const Container = styled.div`
  margin: 24px 30px;
  padding: 24px;

  border-radius: 8px;
  background: #fff;

  h1 {
    font-size: 24px;
  }
`;

export const Rota = styled.h4`
  font-size: 16px;
  line-height: 20px;
  color: #595959;
`;
